export const BET_BOOST= {
  ACTION_TYPES: {
    fetchGames: 'fetchGames',
    onBoostChange: 'onBoostChange',
    ABTestingHandler: 'ABTestingHandler',
    onArrowClick: 'onArrowClick'
  },

  VIEW: {
    list: 'list',
    carousels: 'carousels',
    slider: 'slider'
  },

  CARDS_ORDER_TYPES: {
    byPercentage: 1,
    byBestOdds: 2,
  },

  SUB_SOURCE: {
    sliderPercentage: "Carousel-Percentage",
    sliderOdds: "Carousel-Highest-Odds",
    carousels: "List"
  },

  COMPONENT_TYPE: {
    carousels: 'List',
    slider: 'Carousel'
  }
}